<template>
  <v-toolbar
    flat
    color="transparent">
    <v-spacer></v-spacer>
    <v-btn
        color="primary"
        rounded
        small
        class="text-capitalize"
        @click="nuevo"
      >
        <v-icon left small>
          mdi-plus
        </v-icon>
        Agregar Tipo Archivo
      </v-btn>
  </v-toolbar>
</template>

<script>

export default {
  name: 'ToolBarProyectoDocumentosTipos',
  data() {
    return {};
  },
  methods: {
    nuevo() {
      this.$emit('nuevoTipoArchivoContratista');
    },
  },
};
</script>

<style lang="scss">

</style>
